import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Activity } from '../models/activity.model';
import { Observable } from 'rxjs';
import { Email } from '../models/email.model';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private apiUrl = environment.apiUrl + '/Email';

  http = inject(HttpClient);

  saveEmail(email: Email): Observable<Activity> {
    return this.http.post<Activity>(`${this.apiUrl}/SaveEmail`, email);
  }

  updateEmail(email: Email): Observable<Activity> {
    return this.http.put<Activity>(
      `${this.apiUrl}/UpdateEmail/${email.emailId}`,
      email
    );
  }
}
